import type { CommunicationParticipant } from '@/api/fe-api/entities/communication';
import { label } from '@/utils/format/label';

export function formatParticipant(
  participant: CommunicationParticipant,
): string {
  return participant.name ?? participant.address ?? 'unknown';
}

export function formatParticipants(
  participants: CommunicationParticipant[],
): string {
  if (participants.length === 0) {
    return '';
  }

  if (participants.length === 1) {
    return formatParticipant(participants[0]);
  }

  return `${formatParticipant(participants[0])} and ${participants.length - 1} ${label(['other', 'others'], participants.length)}`;
}
